import { CountryCode, Currency } from './constants';

export function getAmountString(amount: number, currency: Currency) {
  if (currency == null) {
    return amount;
  }
  return amount.toLocaleString("en", { currency, style: 'currency' });
}

const EUR_ONLY: Currency[] = ["EUR"];
const COUNTRY_CURRENCY_MAP: { [K in CountryCode]: Currency[] } = {
  DE: EUR_ONLY,
  ES: EUR_ONLY,
  FR: EUR_ONLY,
  GB: ['GBP'],
  IE: EUR_ONLY,
  NL: EUR_ONLY,
  IT: EUR_ONLY,
  AT: EUR_ONLY,
  BE: EUR_ONLY,
  CZ: ['CZK', 'EUR'],
  DK: ['DKK', 'EUR'],
  EE: EUR_ONLY,
  FI: EUR_ONLY,
  LV: EUR_ONLY,
  LT: EUR_ONLY,
  NO: ['NOK', 'EUR'],
  PL: ['PLN', 'EUR'],
  PT: EUR_ONLY,
  SE: ['SEK', 'EUR'],
  CH: ['CHF', 'EUR'],
};

export function getDefaultCurrencyForCountry(country: Array<CountryCode>): Currency {
  return getAllCurrenciesForCountry(country)[0];
}

export function getAllCurrenciesForCountry(country: Array<CountryCode>): Currency[] {
  const currencies = Array<Currency>();
  country.forEach( countryCode => {
    (COUNTRY_CURRENCY_MAP[countryCode]).forEach(currency => {
      if (currencies.indexOf(currency) === -1) {
        currencies.push(currency)
      }
    })
  })
  return currencies;
}
